







































































































































































































































































































































































































































































































































































































































































































































































































































































































import {Component, Vue} from 'vue-property-decorator';

@Component
export default class GeniePersonalInformationModal extends Vue {
  isVisible: boolean = true;

  onClose() {
    this.isVisible = false;
    this.$emit('input', null);
  }
}
